import React from 'react';

import { Text, View, StyleSheet } from 'react-native';

import { ParticipantAvatar } from '../components';

import { THEME, FONT } from '../../constants/styles';

const NUM_AVATARS = 3;

export const topicLabel = function (topic, currentUserId) {
  if (!topic) return '';
  if (topic.name && topic.name !== '_') return topic.name;

  // return 'Super, Duper, Long, Topic, Name, That Doesnt, Fit';

  const labelMembers = topic.members?.reduce((result, member) => {
    const profile = member.profile || member;
    if (profile.userId !== currentUserId) result.push(_lastName(profile.fullName));
    return result;
  }, []);

  return 'You & ' + labelMembers.join(',');
};

function _lastName(name) {
  if (!name) return '';
  const nameArray = name.split(' ');
  return nameArray[nameArray.length - 1];
}

function _renderAvatar(participant, i) {
  const zIndex = NUM_AVATARS - i;
  const containerStyles = StyleSheet.flatten([styles.avatarContainer, { zIndex }]);
  return (
    <ParticipantAvatar
      key={`${participant.profile.userId}`}
      containerStyles={containerStyles}
      participant={participant}
      circleStyles={styles.profileViewStyle}
    />
  );
}

function _renderExtraAvatar(extraCount) {
  if (extraCount > 0) {
    return (
      <View style={[styles.profileViewStyle, styles.avatarContainer, styles.extraAvatarContainer]}>
        <Text style={styles.extraAvatarText}>+{extraCount}</Text>
      </View>
    );
  }
}

export const TopicFacePile = (props) => {
  const users = props.topic.members;
  const extraCount = users.length - NUM_AVATARS;
  return (
    <View style={styles.facePileContainer}>
      {users.slice(0, NUM_AVATARS).map(_renderAvatar)}
      {_renderExtraAvatar(extraCount)}
    </View>
  );
};

const styles = StyleSheet.create({
  profileViewStyle: {
    width: 40,
    height: 40,
    borderWidth: 2,
    borderColor: 'white',
  },
  avatarContainer: {
    marginLeft: -18,
  },
  facePileContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 10,
    paddingRight: 10,
  },
  extraAvatarContainer: {
    ...THEME.centered,
    backgroundColor: '#777777',
    borderRadius: 20,
    marginLeft: -15,
    paddingLeft: 2,
    zIndex: 0,
  },
  extraAvatarText: {
    ...FONT.medium,
    fontSize: 14,
    color: 'white',
  },
});
